import React from 'react';
import { defaultTheme } from './../../styles/theme/default';
import { IIcon } from './../../@types/icons';

export function Image ({ strokeColor }: IIcon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        stroke={
          strokeColor
            ? defaultTheme.colors[strokeColor]
            : defaultTheme.colors.dimGray
        }
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1.908 14.4h12.184c.612 0 1.108-.44 1.108-.985V2.585c0-.544-.496-.985-1.108-.985H1.908C1.296 1.6.8 2.04.8 2.585v10.83c0 .544.496.985 1.108.985z"
      />
      <path
        stroke={
          strokeColor
            ? defaultTheme.colors[strokeColor]
            : defaultTheme.colors.dimGray
        }
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.6 6.8a1.6 1.6 0 100-3.2 1.6 1.6 0 000 3.2zM10.4 14.4c-.4-2.4-1.697-4-3.036-4.867C5.78 8.508 4.4 8 .8 8M15.2 10.4c-.4-.4-1.416-.8-2.8-.8-1.6 0-2.37.407-3.556.831"
      />
    </svg>
  );
}
